module.exports = __webpack_public_path__ + "img/sway-univeristy-logo.98e2b836.svg";